import { globalModel } from "../global/GlobalModel";

export const PAGE_TITLE_BRAND = "龙粉社";

const CURRENT_SPACE_ID_KEY = "lf-h5-current-space-id";
const SPACE_NAME_KEY_PREFIX = "lf-h5-space-name:";

export function extractSpaceIdFromPathname(pathname: string): string | null {
  const match = pathname.match(/^\/space\/(\d{8})(?:\/|$)/);
  return match ? match[1] : null;
}

/** 有空间名：龙粉社-${空间名称}；否则仅品牌名 */
export function formatLfPageTitle(spaceName?: string | null): string {
  const name = spaceName?.trim();
  if (name) {
    return `${PAGE_TITLE_BRAND}-${name}`;
  }
  return PAGE_TITLE_BRAND;
}

/**
 * 固定两档 document.title：
 * - 平台首页 / 非空间页：龙粉社
 * - 进入空间后（含空间首页与任意子页）：龙粉社-${空间名称}
 */
export function resolveLfPageTitle(pathname: string, spaceName?: string | null): string {
  if (pathname.startsWith("/space/")) {
    const spaceId = extractSpaceIdFromPathname(pathname) ?? readCurrentSpaceId();
    const name = spaceName?.trim() || (spaceId ? resolveSpaceNameForId(spaceId) : null);
    return formatLfPageTitle(name);
  }
  return PAGE_TITLE_BRAND;
}

export function resolveSpaceNameForId(spaceId: string): string | null {
  const remembered = readRememberedSpaceName(spaceId);
  if (remembered) {
    return remembered;
  }
  const recent = globalModel.recentSpaceEntries.find((entry) => entry.id === spaceId);
  if (recent?.name?.trim()) {
    return recent.name.trim();
  }
  const card = globalModel.followSpaceCards.find(
    (item) => item.targetSpaceId === spaceId || item.id === spaceId
  );
  return card?.name?.trim() || null;
}

export function rememberCurrentSpace(spaceId: string, spaceName?: string | null): void {
  if (!spaceId || !/^\d{8}$/.test(spaceId)) {
    return;
  }
  try {
    sessionStorage.setItem(CURRENT_SPACE_ID_KEY, spaceId);
    const name = spaceName?.trim();
    if (name) {
      sessionStorage.setItem(`${SPACE_NAME_KEY_PREFIX}${spaceId}`, name);
    }
    if (typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent("lf-h5-space-name-updated", { detail: { spaceId } })
      );
    }
  } catch {
    /* ignore quota / privacy mode */
  }
}

export function readCurrentSpaceId(): string | null {
  try {
    return sessionStorage.getItem(CURRENT_SPACE_ID_KEY);
  } catch {
    return null;
  }
}

function readRememberedSpaceName(spaceId: string): string | null {
  try {
    return sessionStorage.getItem(`${SPACE_NAME_KEY_PREFIX}${spaceId}`);
  } catch {
    return null;
  }
}
